import { styled } from '@mui/material/styles';
import { Tooltip, tooltipClasses } from '@mui/material';

const LightTooltip = styled(
	({ className, placement = 'bottom-start', customStyles, ...props }) => (
		<Tooltip {...props} placement={placement} classes={{ popper: className }} />
	)
)(({ theme, customStyles }) => {
	return {
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: theme.palette.common.white,
			color: 'rgba(0, 0, 0, 0.87)',
			boxShadow: theme.shadows[1],
			fontSize: 11,
			maxWidth: '400px',
			borderRadius: '0px',
			...customStyles,
		},
	};
});

export default LightTooltip;
